// Utilitário compartilhado: permite arrastar com o mouse (desktop) qualquer track de
// scroll horizontal. Touch (mobile) já rola nativamente, então isso só entra em ação
// com mousedown/mousemove/mouseup. Usado por panda-carousel.js e panda-produto-main.js.
window.pandaEnableDragScroll = function (track) {
  if (!track || track.__pandaDragEnabled) return;
  track.__pandaDragEnabled = true;
  track.classList.add('panda-drag-scroll');

  // Impede o drag nativo de imagens/links dentro do track — compete com o nosso
  // drag customizado e causa travamento/soltar sozinho. O listener de dragstart
  // no track (delegação) cobre também cards injetados depois via AJAX.
  track.querySelectorAll('img, a').forEach(function (el) {
    el.setAttribute('draggable', 'false');
  });
  track.addEventListener('dragstart', function (e) {
    e.preventDefault();
  });

  var isDown = false;
  var moved = false;
  var startX = 0;
  var startScrollLeft = 0;
  var overscroll = 0;
  var RESISTANCE = 0.4;

  function blockClickOnce(e) {
    e.preventDefault();
    e.stopPropagation();
    track.removeEventListener('click', blockClickOnce, true);
  }

  function setOverscroll(px) {
    overscroll = px;
    track.style.transform = px ? 'translateX(' + px + 'px)' : '';
  }

  track.addEventListener('mousedown', function (e) {
    e.preventDefault();
    isDown = true;
    moved = false;
    startX = e.pageX;
    startScrollLeft = track.scrollLeft;
    track.classList.add('panda-is-dragging');
    track.style.transition = 'none';
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    var delta = e.pageX - startX;
    if (Math.abs(delta) > 4) moved = true;
    var target = startScrollLeft - delta;
    var max = track.scrollWidth - track.clientWidth;
    if (target < 0) {
      track.scrollLeft = 0;
      setOverscroll(-target * RESISTANCE);
    } else if (target > max) {
      track.scrollLeft = max;
      setOverscroll(-(target - max) * RESISTANCE);
    } else {
      track.scrollLeft = target;
      if (overscroll) setOverscroll(0);
    }
  });

  document.addEventListener('mouseup', function () {
    if (!isDown) return;
    isDown = false;
    track.classList.remove('panda-is-dragging');
    if (overscroll) {
      track.style.transition = 'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)';
      setOverscroll(0);
    }
    if (moved) track.addEventListener('click', blockClickOnce, true);
  });
};
